import isEmpty from "lodash/isEmpty";
import { isInClusterTest } from "./clusterized-pricing-page-service";
const DEFAULT_CONTACT_SALES_LINK = "/sales/contact-us?from=pricing&source=Website%20-%20Contact%20Sales";
const getClusterContactUsLinksByTier = (clusterConfig, abTests, cookies, forcePricing)=>{
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    const contactUsLinks = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.contact_us_links;
    if (!isEmpty(contactUsLinks) && isInClusterTest(clusterConfig, {
        abTests,
        cookies,
        forcePricing
    })) {
        return contactUsLinks;
    }
    return {};
};
export const getPricingContactUsLink = (tier, clusterConfig, abTests, cookies, forcePricing)=>{
    const contactUsLinksByTier = getClusterContactUsLinksByTier(clusterConfig, abTests, cookies, forcePricing);
    const { [tier]: contactUsLink } = contactUsLinksByTier;
    return contactUsLink || getDefaultContactUsPageLink();
};
export const getDefaultContactUsPageLink = ()=>{
    return DEFAULT_CONTACT_SALES_LINK;
};
